export function initBackToTop() {
    document
        .querySelectorAll('[data-back-to-top]')
        .forEach((button) => {
            const toggleVisibility = () => {
                button.classList.toggle(
                    'is-visible',
                    window.scrollY > 300
                );
            };

            window.addEventListener('scroll', toggleVisibility);

            button.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });

            toggleVisibility();
        });
}

